export default function FailedIcon() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7495 16.25H18.7495M11.2495 16.25H12.7495M2.24951 9.5799H21.7495M3.00006 5.75H21.0001C21.4143 5.75 21.7501 6.08579 21.7501 6.5V18.5C21.7501 18.9142 21.4143 19.25 21.0001 19.25H3.00006C2.58585 19.25 2.25006 18.9142 2.25006 18.5V6.5C2.25006 6.08579 2.58585 5.75 3.00006 5.75Z"
        stroke="#B721FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="14" y="11.5" width="11" height="11" rx="5.5" fill="#FBF4FF" />
      <path
        d="M20.875 15.625L18.125 18.375M20.875 18.375L18.125 15.625M23.625 17C23.625 19.2782 21.7782 21.125 19.5 21.125C17.2218 21.125 15.375 19.2782 15.375 17C15.375 14.7218 17.2218 12.875 19.5 12.875C21.7782 12.875 23.625 14.7218 23.625 17Z"
        stroke="#B721FF"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
